<script>
// Taken and slightly modified from here:
// https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
// https://github.com/maoberlehner/transition-to-height-auto-with-vue

export default {
  name: 'TransitionHeightExpand',
  functional: true,
  render (createElement, context) {
    const data = {
      props: {
        name: 'height-expand'
      },
      on: {
        afterEnter (element) {
          element.style.height = 'auto'
        },
        enter (element) {
          const width = Math.ceil(
            element.getBoundingClientRect().width)

          element.style.width = width
          element.style.position = 'absolute'
          element.style.visibility = 'hidden'
          element.style.height = 'auto'

          // Also getComputedStyle(element) can be used
          // to obtain the string `{height}px` or `{width}` value,
          // but it has a bug in IE when "box-sizing" style is set to border-box, see
          // https://stackoverflow.com/questions/19717907/
          // getcomputedstyle-reporting-different-heights-between-chrome-safari-firefox-and-i
          // (2-line url above)

          // Rounding up here is used to prevent the overflow
          // due to rounding errors that may impact
          // such properties as column-count, for instance
          const height = Math.ceil(
            element.getBoundingClientRect().height)

          // Reset all the styles previously modified.
          // '' value is used for resetting instead of a null
          // since the null doesn't work in IE
          element.style.width = ''
          element.style.position = ''
          element.style.visibility = ''
          element.style.height = 0

          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          getComputedStyle(element).height

          setTimeout(() => {
            // round up pixels
            element.style.height = `${height}px`
          })
        },
        leave (element) {
          const height = Math.ceil(
            element.getBoundingClientRect().height)

          element.style.height = `${height}px`
          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          getComputedStyle(element).height
          setTimeout(() => {
            element.style.height = 0
          })
        }
      }
    }
    return createElement('transition', data, context.children)
  }
}
</script>

<style scoped>
  * {
    /* Hardware acceleration for modern browsers */
    will-change: height;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
</style>

<style>
  .height-expand-enter-active,
  .height-expand-leave-active {
    transition: height 0.5s ease-in-out;
    overflow: hidden;
  }
  .height-expand-enter,
  .height-expand-leave-to {
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/TransitionHeightExpand.vue